import styled from "styled-components";

// Popover wrapper for the color picker
export const ColorPop = styled.div`
    position: absolute;
    top: 110%;
    left: 0;
    z-index: 20;
`;

// Covers the rest of the UI when picker is open (click to close)
export const ColorCover = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

// Wrapper around the color trigger and preview
export const PickerWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

//Main Circle
export const MainCircle = styled.div`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D8DEEC;
    opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
`;

// Circular button with conic color wheel background
export const OuterCircle = styled.div`
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background: conic-gradient(
    #FD6096 0deg 20deg, #F9B200 20deg 40deg,
    #FFDF46 40deg 60deg, #C0FF66 60deg 80deg,#9BE058 80deg 100deg,
    #1CC939 100deg 120deg, #17B5BA 120deg 140deg, #1DD1D9 140deg 160deg, 
    #3FEFEF 160deg 180deg, #83D9FF 180deg 200deg, #64BDFF 200deg 220deg,
    #43A3F9 220deg 240deg, #1685FB 240deg 260deg, #364EC6 260deg 280deg,
    #4A5BE5 280deg 300deg, #7884EA 300deg 320deg,
    #F01054 320deg 340deg, #FC3E81 340deg 360deg

    );
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 1;
`;

// Inner white circle to hold the icon
export const ColorCircle = styled.div`
    width: ${p => p.width || "55px"};
    height: ${p => p.height || "54px"};
    background: #83D9FF 0% 0% no-repeat padding-box;
    border-radius: 50%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Displays the currently selected color
export const SelectedColorPreview = styled.div`
    width: 55px;
    height: 54px;
    border-radius: 50%;
    box-shadow: 0 3px 6px #808080;
    background-color: ${p => p.color || "#FFFFFF"};
    box-shadow: 0px 3px 6px #00000029;
    border: 2px dashed #D8DEEC;
    opacity: 1;
    flex-shrink: 0;
`;
